import { render, staticRenderFns } from "./SectionWhatSmartPOST.vue?vue&type=template&id=010090f4&scoped=true"
import script from "./SectionWhatSmartPOST.vue?vue&type=script&lang=ts"
export * from "./SectionWhatSmartPOST.vue?vue&type=script&lang=ts"
import style0 from "./SectionWhatSmartPOST.vue?vue&type=style&index=0&id=010090f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010090f4",
  null
  
)

export default component.exports